export default __webpack_public_path__ + "static/media/lightningarc.bf071f4e.png";